var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactTestingLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9119 18.2496C45.0188 22.561 40.2638 27.61 34.3165 26.1795C41.8915 20.6701 38.4282 13.613 34.4248 10.2277C30.0839 6.55594 34.2863 5.37961 35.6864 6.70887C35.6527 4.02697 26.21 4.63307 34.4693 13.2451C38.7127 17.6685 33.7069 27.4535 27.7437 20.0127C27.6945 19.9452 27.6499 19.8745 27.6105 19.8012C28.5734 19.4013 29.3643 18.3136 29.3643 16.5222C29.3737 15.888 29.2476 15.2591 28.9946 14.6776C29.684 13.2736 30.3166 11.5961 30.3166 9.49553C30.3166 4.47469 27.0594 0 22.4982 0C17.9367 0 14.6798 4.47486 14.6798 9.49535C14.6798 11.5959 15.3142 13.2754 16.0035 14.6793C15.7495 15.2619 15.6236 15.8922 15.634 16.5277C15.634 18.3189 16.4229 19.4066 17.3878 19.8065C17.3477 19.88 17.3025 19.9506 17.2528 20.018C11.2894 27.4588 6.28225 17.6722 10.5272 13.2504C18.788 4.63834 9.3419 4.03418 9.30815 6.71414C10.7084 5.38664 14.9126 6.56297 10.5697 10.2329C6.56649 13.6095 3.10676 20.6684 10.6782 26.1847C4.73256 27.6154 -0.0205628 22.5664 1.08282 18.2551C-0.84691 21.8094 0.583598 28.5305 8.24379 29.828C0.0894764 31.6993 2.54338 42.9594 8.28475 41.1572C3.36077 40.8676 3.90815 35.2002 5.9001 33.4942C8.10352 31.6051 10.8897 32.9361 15.9699 32.0848C15.9147 36.6594 20.3695 39.1171 18.0329 41.7366C15.5575 44.509 12.169 41.5146 12.6914 38.7902C10.3282 43.6809 17.0573 47.5729 20.0071 41.8931C22.2797 37.5231 16.2401 29.6306 22.4947 29.6306C28.7494 29.6306 22.708 37.5142 24.9824 41.8931C27.932 47.5799 34.6613 43.6808 32.2979 38.7902C32.815 41.5164 29.4318 44.509 26.9583 41.7366C24.6322 39.1101 29.0748 36.6521 29.0266 32.0778C34.1049 32.9291 36.8912 31.5962 39.0929 33.487C41.0883 35.1932 41.6338 40.8605 36.71 41.1502C42.4601 42.9594 44.9123 31.6974 36.7545 29.8208C44.4094 28.5253 45.8416 21.8021 43.9119 18.2496Z",
    fill: "url(#paint0_radial_316_301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99415 33.8354C8.19581 31.9463 10.7244 33.599 15.975 32.0778C15.975 32.0778 16.048 30.6738 16.1156 29.6325C14.5164 30.8373 11.5915 30.6809 9.15012 31.0382C1.11481 32.2165 2.89881 41.8681 8.28475 41.1573C4.29909 40.5033 4.00061 35.5433 5.99432 33.8354",
    fill: "url(#paint1_linear_316_301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4246 26.9186C17.3132 25.5449 17.4234 23.3305 15.627 25.3441C9.55687 32.1453 -0.974884 26.5881 1.08809 18.2513C-1.13291 21.2672 -0.0667974 29.1526 8.24906 29.8225C10.337 29.1294 14.6354 29.666 16.4246 26.9186Z",
    fill: "url(#paint2_linear_316_301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6799 26.1795C10.6799 26.1795 12.8122 25.9608 14.1947 24.3364C8.57426 26.4265 3.96316 17.3611 10.9962 11.2335C16.4656 6.47405 10.8984 4.59759 9.30287 6.7089C9.89104 6.12776 14.6566 6.45647 10.314 10.128C6.31758 13.5136 2.08318 20.5422 10.6799 26.1795Z",
    fill: "url(#paint3_radial_316_301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5407 42.6537C24.2005 40.0342 26.5407 37.6687 26.9707 33.5405C27.2551 30.7556 26.2155 27.6757 22.5 27.6757C18.7845 27.6757 17.7434 30.7609 18.0294 33.5405C18.4541 37.6687 20.7977 40.0342 18.4593 42.6537C15.9859 45.4244 11.3606 42.5364 12.6967 38.783C9.40782 44.2443 17.7557 47.6441 20.7053 41.9659C22.9764 37.5942 16.2452 29.9328 22.5 29.9328C28.7548 29.9328 22.0236 37.5942 24.2947 41.9659C27.2443 47.6439 35.5904 44.2443 32.3016 38.783C33.6359 42.5364 29.0141 45.4226 26.5407 42.6537Z",
    fill: "url(#paint4_radial_316_301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8499 31.04C33.4067 30.6846 30.4801 30.8373 28.8844 29.6325C28.9538 30.6738 29.025 32.0796 29.025 32.0796C34.2738 33.599 36.8024 31.9446 39.0041 33.8354C40.9976 35.5416 40.6992 40.5033 36.7065 41.1502C42.0994 41.8681 43.8852 32.2165 35.8499 31.04Z",
    fill: "url(#paint5_linear_316_301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9119 18.2496C45.9749 26.5847 35.4431 32.1453 29.3713 25.3407C27.5748 23.3271 27.6797 25.5431 28.5754 26.9169C30.3646 29.6643 34.6613 29.1277 36.7492 29.8208C45.0668 29.1526 46.1329 21.2655 43.9119 18.2496Z",
    fill: "url(#paint6_linear_316_301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8053 24.3364C32.1878 25.9608 34.3183 26.1795 34.3183 26.1795C42.9151 20.5492 38.6807 13.5118 34.6737 10.128C30.3291 6.45645 35.0947 6.12773 35.6829 6.70887C34.0836 4.59756 28.5202 6.4742 33.9896 11.2335C41.0349 17.3612 36.424 26.4263 30.8053 24.3364Z",
    fill: "url(#paint7_radial_316_301)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.8099 6.24677C24.8099 7.63298 22.5 7.63298 22.5 6.24677C22.5 4.86056 24.8099 4.86231 24.8099 6.24677ZM21.1727 7.51573C21.1727 8.47005 19.5859 8.47005 19.5859 7.51573C19.5859 6.56124 21.1727 6.56124 21.1727 7.51573ZM22.1855 3.12612C22.1855 4.0822 20.597 4.0822 20.597 3.12612C20.597 2.16987 22.1855 2.17884 22.1855 3.12612ZM18.8768 9.89897C18.8768 10.3769 18.0826 10.3769 18.0826 9.89897C18.0826 9.42085 18.8768 9.42085 18.8768 9.89897ZM19.028 5.2072C19.028 5.86813 17.9297 5.86813 17.9297 5.2072C17.9297 4.54608 19.028 4.54784 19.028 5.2072ZM22.1855 11.0203C22.1855 11.683 21.0874 11.683 21.0874 11.0203C21.0874 10.3574 22.1855 10.3627 22.1855 11.0203Z",
    fill: "#4B1313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6782 16.5222C19.6782 19.0424 16.821 19.0424 16.821 16.5222C16.821 14.0022 19.6782 14.0022 19.6782 16.5222Z",
    fill: "#302D3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2141 15.8808C18.2196 15.9417 18.2123 16.0031 18.1927 16.0611C18.1731 16.1191 18.1417 16.1723 18.1004 16.2175C18.0591 16.2626 18.0089 16.2987 17.9529 16.3234C17.8969 16.348 17.8364 16.3608 17.7752 16.3608C17.714 16.3608 17.6535 16.348 17.5975 16.3234C17.5415 16.2987 17.4912 16.2626 17.45 16.2175C17.4087 16.1723 17.3772 16.1191 17.3577 16.0611C17.3381 16.0031 17.3308 15.9417 17.3362 15.8808C17.3308 15.8198 17.3381 15.7584 17.3577 15.7004C17.3772 15.6425 17.4087 15.5892 17.45 15.5441C17.4912 15.4989 17.5415 15.4628 17.5975 15.4382C17.6535 15.4135 17.714 15.4008 17.7752 15.4008C17.8364 15.4008 17.8969 15.4135 17.9529 15.4382C18.0089 15.4628 18.0591 15.4989 18.1004 15.5441C18.1417 15.5892 18.1731 15.6425 18.1927 15.7004C18.2123 15.7584 18.2196 15.8198 18.2141 15.8808Z",
    fill: "#6F828A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1862 16.5222C28.1862 19.0424 25.3288 19.0424 25.3288 16.5222C25.3288 14.0022 28.1862 14.0022 28.1862 16.5222Z",
    fill: "#302D3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7131 15.8808C26.7186 15.9417 26.7113 16.0031 26.6917 16.0611C26.6721 16.1191 26.6407 16.1723 26.5994 16.2175C26.5581 16.2626 26.5079 16.2987 26.4519 16.3234C26.3959 16.348 26.3354 16.3608 26.2742 16.3608C26.213 16.3608 26.1525 16.348 26.0965 16.3234C26.0405 16.2987 25.9903 16.2626 25.949 16.2175C25.9077 16.1723 25.8763 16.1191 25.8567 16.0611C25.8371 16.0031 25.8298 15.9417 25.8353 15.8808C25.8298 15.8198 25.8371 15.7584 25.8567 15.7004C25.8763 15.6425 25.9077 15.5892 25.949 15.5441C25.9903 15.4989 26.0405 15.4628 26.0965 15.4382C26.1525 15.4135 26.213 15.4008 26.2742 15.4008C26.3354 15.4008 26.3959 15.4135 26.4519 15.4382C26.5079 15.4628 26.5581 15.4989 26.5994 15.5441C26.6407 15.5892 26.6721 15.6425 26.6917 15.7004C26.7113 15.7584 26.7186 15.8198 26.7131 15.8808Z",
    fill: "#6F828A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1727 21.5374C21.1727 22.9734 21.0537 24.1357 20.9167 24.1357C20.78 24.1357 20.6698 22.9734 20.6715 21.5394C20.6733 20.105 20.7905 18.941 20.9292 18.941C21.0677 18.941 21.1762 20.1015 21.1727 21.5374Z",
    fill: "#9E1C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5462 24.587C22.6503 24.587 22.7347 23.2209 22.7347 21.5356C22.7347 19.8504 22.6503 18.4843 22.5462 18.4843C22.4422 18.4843 22.3578 19.8504 22.3578 21.5356C22.3578 23.2209 22.4422 24.587 22.5462 24.587Z",
    fill: "#9E1C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3267 21.5037C24.3267 22.9041 24.213 24.0397 24.078 24.0397C23.9428 24.0397 23.8416 22.9076 23.8433 21.5054C23.8451 20.1032 23.9606 18.9694 24.092 18.9694C24.2235 18.9694 24.332 20.1032 24.3267 21.5037Z",
    fill: "#9E1C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9882 25.5058C34.6932 25.1149 36.4097 23.8247 36.7082 24.2174C37.0067 24.6101 35.2814 25.8985 34.9882 25.5058Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4146 25.2642C35.2814 25.0865 36.2215 24.3756 36.3563 24.5533C36.4915 24.7308 35.5496 25.4436 35.4146 25.2642Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0046 23.7873C35.6491 23.4462 36.9552 22.1043 37.3071 22.4455C37.6588 22.7867 36.3493 24.1304 36.0046 23.7873Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3386 23.526C36.1768 23.3696 36.8912 22.6375 37.0494 22.7921C37.2076 22.9468 36.4985 23.6825 36.3386 23.526Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8545 21.2977C37.3852 21.1535 37.9308 19.3641 38.3998 19.5078C38.8691 19.652 38.3145 21.4432 37.8543 21.2975",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0373 20.9101C37.8223 20.8443 38.1226 19.867 38.334 19.931C38.5455 19.995 38.2488 20.9758 38.0373 20.9101Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.055 25.4401C32.847 24.9957 34.7323 24.1144 34.9385 24.5603C35.1445 25.0064 33.261 25.8843 33.055 25.4401Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5169 25.2979C33.4227 25.0935 34.4516 24.612 34.5475 24.8145C34.6435 25.0172 33.6004 25.5006 33.5169 25.2979Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7816 22.9059C37.3711 22.641 38.3875 21.0683 38.7962 21.3367C39.2049 21.6049 38.1955 23.1724 37.7816 22.9059Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0675 22.5842C37.8793 22.4615 38.4354 21.6033 38.6219 21.7241C38.8085 21.8448 38.2542 22.7049 38.0675 22.5842Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1957 27.9689C30.3859 27.4838 32.1504 28.1786 31.9728 28.6657C31.795 29.1526 30.0039 28.456 30.1957 27.9689Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5726 28.1841C30.6596 27.9619 31.628 28.344 31.5429 28.5643C31.4575 28.7847 30.4836 28.4114 30.5726 28.1841Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6818 28.5395C32.815 27.9334 34.6365 28.3368 34.5048 28.9429C34.3733 29.5488 32.5466 29.1454 32.6818 28.5395Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.078 28.7172C33.1402 28.4383 34.1441 28.6603 34.0766 28.9357C34.0091 29.2112 33.0158 28.9837 33.078 28.7172Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6534 25.8577C29.1013 25.3638 30.6401 26.7658 30.1941 27.2563C29.748 27.7467 28.2057 26.3499 28.6534 25.8577Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9448 26.2292C29.151 26.0035 29.9914 26.7711 29.7872 26.9951C29.5827 27.219 28.7406 26.4619 28.9448 26.2292Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1357 29.2201C35.1357 28.7972 36.7135 28.8292 36.7047 29.2521C36.6959 29.675 35.125 29.6448 35.1357 29.2201Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4874 29.2824C35.4874 29.0869 36.3493 29.1046 36.3475 29.2964C36.3458 29.4885 35.4839 29.4743 35.4874 29.2824Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3073 30.8853C29.4405 30.2793 31.262 30.6828 31.1323 31.2887C31.0025 31.8948 29.1741 31.4914 29.3073 30.8853Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7035 31.0542C29.7657 30.7751 30.7698 30.9955 30.7023 31.2727C30.6348 31.5499 29.6415 31.3279 29.7037 31.0542",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3912 28.9073C21.3912 28.2871 23.5981 28.2569 23.6071 28.879C23.6159 29.5009 21.4001 29.5293 21.3912 28.9074",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8941 28.9802C21.8941 28.696 23.1006 28.68 23.1059 28.9624C23.1112 29.2451 21.8976 29.2628 21.8941 28.9802Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2503 29.6503C24.682 29.2041 26.0272 30.5103 25.5883 30.9545C25.1494 31.3989 23.8185 30.0962 24.2503 29.6503Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4972 30.002C24.698 29.7977 25.4283 30.5121 25.2329 30.7128C25.0374 30.9138 24.3018 30.2029 24.4972 30.002Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3879 31.4149C27.0063 31.4486 26.9032 33.3165 26.283 33.2827C25.6628 33.249 25.7678 31.3829 26.3879 31.4149Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2848 31.8326C26.5692 31.8484 26.5122 32.8704 26.2315 32.8544C25.9508 32.8386 26.0023 31.8166 26.2848 31.8326Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3236 33.3005C25.9313 33.4248 25.5581 35.2552 24.9504 35.1362C24.3427 35.0172 24.7159 33.178 25.3236 33.3005Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1654 33.6932C25.4443 33.7519 25.2401 34.7595 24.9629 34.699C24.6857 34.6387 24.8864 33.6435 25.1654 33.6932Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9242 35.2499C26.5319 35.3744 26.1587 37.205 25.551 37.084C24.9432 36.9633 25.3165 35.1274 25.9242 35.2499Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7625 35.6481C26.0415 35.705 25.8388 36.7144 25.5598 36.6521C25.2809 36.5899 25.4871 35.5913 25.7625 35.6481Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5327 37.2832C25.1387 37.4057 24.7674 39.2379 24.1597 39.1154C23.5519 38.9927 23.9215 37.1587 24.5327 37.283",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3693 37.6812C24.65 37.7399 24.4457 38.7475 24.1685 38.6852C23.8913 38.623 24.0993 37.6244 24.3693 37.6812Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8774 39.4264C25.4958 39.4496 25.4266 41.319 24.8064 41.296C24.1863 41.2729 24.2555 39.4033 24.8774 39.4264Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7816 39.8475C25.0676 39.86 25.0286 40.8818 24.746 40.8712C24.4635 40.8605 24.5007 39.8369 24.7816 39.8475Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5682 42.0743C25.0499 41.6833 26.036 42.8989 25.5526 43.29C25.0694 43.6809 24.0868 42.4635 24.5682 42.0743Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.73 42.4013C24.9522 42.2237 25.4906 42.8882 25.2631 43.0661C25.0356 43.2436 24.5115 42.5792 24.73 42.4013Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1925 43.226C26.4412 42.7746 27.5785 43.4035 27.3298 43.8514C27.0809 44.2993 25.9437 43.6774 26.1925 43.226Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4182 43.425C26.5319 43.2171 27.1538 43.56 27.0418 43.7643C26.9299 43.9689 26.3044 43.6312 26.4182 43.425Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6282 44.6015C27.6655 44.1339 28.7814 44.2246 28.7423 44.692C28.7031 45.1596 27.5892 45.0671 27.6282 44.6015Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8752 44.6798C27.8928 44.4664 28.5024 44.5145 28.4864 44.7277C28.4706 44.941 27.8575 44.8895 27.8752 44.6798Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1885 44.3224C29.0888 43.9066 30.0767 43.6667 30.1799 44.0826C30.2829 44.4983 29.2896 44.7383 29.1885 44.3224Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.43 44.3189C29.3855 44.1306 29.9275 43.999 29.9737 44.1856C30.0199 44.3723 29.471 44.5091 29.43 44.3189Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6844 44.3563C30.5209 43.9599 31.4645 43.5688 31.6262 43.9652C31.7879 44.3615 30.8516 44.7437 30.6846 44.3563",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9173 44.3083C30.8443 44.1306 31.3597 43.9154 31.4343 44.0931C31.509 44.2708 30.9918 44.4895 30.9173 44.3083Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5267 43.3005C31.2138 43.0091 31.9106 42.261 32.2216 42.5524C32.5325 42.8438 31.8394 43.592 31.5267 43.3005Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7239 43.1673C31.5817 43.0323 31.9604 42.6234 32.1024 42.7567C32.2446 42.8901 31.8662 43.3005 31.7239 43.1673Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6763 41.9642C32.2659 41.8468 32.5503 40.864 32.9607 40.985C33.3712 41.1057 33.085 42.0852 32.6763 41.9642Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.792 41.7581C32.6143 41.7029 32.7598 41.1662 32.9465 41.2249C33.133 41.2835 32.9838 41.8149 32.7918 41.7581",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5765 32.3728C31.6297 31.7561 33.492 31.9161 33.4369 32.5362C33.3819 33.1566 31.5214 32.9931 31.5765 32.3728Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9904 32.4882C32.0172 32.204 33.0335 32.2945 33.0087 32.5754C32.9838 32.8562 31.9657 32.7691 31.9904 32.4882Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8119 31.7224C33.8242 31.1128 35.6919 31.1502 35.6776 31.7614C35.6636 32.3728 33.7976 32.3337 33.8119 31.7224Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2276 31.8094C34.2276 31.5286 35.2547 31.5517 35.2494 31.8291C35.2441 32.1063 34.2276 32.0938 34.2276 31.8094Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9281 32.4954C36.0613 31.909 37.6891 32.2804 37.5506 32.8704C37.4119 33.4605 35.7913 33.0853 35.9281 32.4954Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2783 32.6554C36.3403 32.387 37.2289 32.5915 37.1667 32.8579C37.1044 33.1246 36.216 32.9254 36.2783 32.6554Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1885 32.5399C38.4638 32.0068 39.8232 32.7034 39.5441 33.2508C39.2651 33.7981 37.9129 33.0783 38.1885 32.5399Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4602 32.7674C38.5882 32.5202 39.3274 32.9059 39.2048 33.1476C39.0822 33.3893 38.334 33.0126 38.4602 32.7674Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6206 34.0787C40.0702 33.8762 40.5856 35.0174 40.1342 35.2199C39.6828 35.4224 39.1692 34.2833 39.6206 34.0789",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6791 34.3651C39.8853 34.2709 40.166 34.8982 39.9635 34.987C39.761 35.0759 39.4731 34.4556 39.6793 34.3651",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8804 35.4561C41.3726 35.4561 41.3691 36.7091 40.8804 36.7001C40.3917 36.6913 40.3864 35.4544 40.8804 35.4561Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8146 35.7405C41.0439 35.7405 41.0403 36.4247 40.8146 36.4247C40.5889 36.4247 40.5907 35.7388 40.8146 35.7405Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3989 37.0698C40.8378 37.1498 40.6317 38.2713 40.191 38.1878C39.7503 38.1041 39.9565 36.9933 40.3989 37.0698Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.294 37.3187C40.4984 37.3577 40.3847 37.9691 40.1839 37.9318C39.983 37.8944 40.0915 37.2814 40.294 37.3187Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4469 38.6925C40.8022 38.8897 40.2975 39.789 39.9422 39.581C39.5868 39.3731 40.0915 38.4915 40.4467 38.6925",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.294 38.8684C40.4557 38.9607 40.1802 39.4513 40.0185 39.3588C39.8568 39.2664 40.1305 38.7777 40.294 38.8684Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3914 39.8865C39.6383 40.1267 39.0271 40.7558 38.7802 40.5123C38.5332 40.2687 39.1444 39.6433 39.3914 39.8865Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2226 39.9969C39.3363 40.1087 39.0004 40.4501 38.8886 40.3397C38.7765 40.2296 39.1089 39.8867 39.2226 39.9969Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0192 28.9642C36.8787 28.3723 38.6967 27.9406 38.8387 28.536C38.9809 29.1312 37.1614 29.5613 37.0192 28.9642Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4509 28.9447C37.3869 28.671 38.3785 28.4363 38.4442 28.7065C38.51 28.9767 37.513 29.2149 37.4509 28.9447Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3486 29.1241C39.1711 28.6177 40.9337 27.9991 41.1114 28.5075C41.2891 29.0157 39.5246 29.6342 39.3486 29.1241Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7698 29.0496C39.6881 28.8149 40.6584 28.479 40.7348 28.71C40.8111 28.9411 39.8515 29.2825 39.7698 29.0496Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9391 27.7949C40.5837 27.395 41.9625 26.1385 42.3251 26.5366C42.6876 26.9346 41.2998 28.1928 40.9391 27.7949Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.298 27.5602C41.1328 27.3827 41.8915 26.6911 42.055 26.8706C42.2184 27.0502 41.4633 27.7414 41.298 27.5602Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2011 26.5064C42.7516 26.2078 43.791 24.651 44.2389 24.9495C44.6866 25.2482 43.6453 26.8049 43.2011 26.5064Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4907 26.1918C43.2863 26.0532 43.855 25.2056 44.0575 25.3389C44.2601 25.4721 43.695 26.3268 43.4907 26.1918Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.839 24.2866C43.3345 24.0966 43.9989 22.3478 44.4999 22.5362C45.001 22.7246 44.3399 24.4786 43.839 24.2866Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0522 23.9189C43.8212 23.83 44.1854 22.8739 44.4076 22.9609C44.6296 23.0481 44.2814 24.0024 44.0522 23.9189Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7683 21.8716C44.3739 21.9161 44.2229 20.5404 44.6171 20.4961C45.0118 20.4516 45.1645 21.8271 44.7683 21.8716Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7843 21.5552C44.6066 21.5729 44.5231 20.8213 44.7008 20.8035C44.8784 20.7858 44.9655 21.5339 44.7843 21.5552Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0733 19.8703C38.5882 19.8118 38.8157 17.9529 39.3008 18.0151C39.786 18.0774 39.5583 19.9308 39.0733 19.8703Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1869 19.4581C38.9631 19.4316 39.0894 18.415 39.3096 18.4416C39.53 18.4683 39.4091 19.4848 39.1871 19.4581",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3467 18.383C37.8598 18.4238 37.7086 16.5579 38.199 16.5187C38.6895 16.4796 38.8371 18.3438 38.3467 18.383Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3748 17.9547C38.151 17.9724 38.071 16.9541 38.2932 16.9346C38.5152 16.9151 38.5989 17.9387 38.375 17.9547",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8707 16.062C38.4265 16.2664 37.6501 14.5656 38.096 14.3613C38.542 14.1569 39.3186 15.8593 38.8707 16.062Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7517 15.6516C38.5492 15.7438 38.1245 14.8163 38.3252 14.722C38.526 14.6278 38.9559 15.5663 38.7517 15.6516Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3922 14.6936C36.9925 14.9175 36.1485 13.3963 36.5502 13.1741C36.9517 12.9519 37.7956 14.4696 37.3922 14.6936Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2484 14.3221C37.0708 14.4253 36.605 13.5953 36.7882 13.4923C36.9712 13.3891 37.4368 14.2191 37.2484 14.3221Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1187 12.8187C36.7777 13.0853 35.7968 11.8271 36.1413 11.5586C36.486 11.2902 37.4651 12.545 37.1187 12.8187Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.941 12.4988C36.7845 12.6215 36.248 11.9336 36.408 11.8111C36.568 11.6884 37.0992 12.3762 36.941 12.4988Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4714 12.0528C35.1427 12.3388 34.1016 11.1303 34.432 10.846C34.7625 10.5616 35.7966 11.7684 35.4714 12.0528Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2707 11.7434C35.1213 11.8751 34.56 11.2103 34.702 11.0842C34.8442 10.958 35.4234 11.6137 35.2707 11.7434Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7235 10.4426C34.4266 10.6986 33.5756 9.71032 33.8741 9.45456C34.1726 9.19862 35.022 10.1849 34.7235 10.4424",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5688 10.1848C34.432 10.3022 33.9664 9.76203 34.1033 9.65182C34.2401 9.5416 34.7038 10.0695 34.5688 10.185",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2965 10.1245C32.9625 10.3272 32.2854 9.21288 32.6232 9.00844C32.9607 8.80401 33.6359 9.91811 33.2965 10.1245Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1864 9.84552C33.0353 9.93798 32.664 9.33013 32.8168 9.23591C32.9697 9.14169 33.3392 9.75306 33.1864 9.84552Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1615 8.78628C32.7865 8.89649 32.497 7.9297 32.8755 7.81772C33.2539 7.70575 33.5347 8.67255 33.1615 8.78628Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1365 8.55177C32.959 8.60327 32.8078 8.07364 32.9803 8.01862C33.1525 7.96343 33.309 8.50027 33.1367 8.55177",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1219 7.70943C31.7524 7.5797 32.0864 6.62697 32.4578 6.75846C32.8293 6.89012 32.4932 7.84267 32.1219 7.70943Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2446 7.51028C32.0671 7.4535 32.2587 6.9309 32.4221 6.99137C32.5856 7.05184 32.4134 7.56899 32.2446 7.51028Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.062 6.60761C32.9998 6.22001 33.9949 6.06374 34.0569 6.45292C34.1193 6.8421 33.1225 7.0003 33.062 6.60761Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2947 6.6217C33.2663 6.44416 33.8119 6.36049 33.8384 6.53645C33.8651 6.71223 33.3232 6.79942 33.2947 6.6217Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0135 25.5058C10.3068 25.1149 8.59201 23.8247 8.29177 24.2174C7.99154 24.6101 9.71859 25.8985 10.0135 25.5058Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58536 25.2642C9.7186 25.0865 8.77852 24.3756 8.6437 24.5533C8.50852 24.7308 9.45036 25.4436 9.58536 25.2642Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99543 23.7873C9.35086 23.4462 8.04481 22.1043 7.6929 22.4455C7.34116 22.7867 8.65073 24.1304 8.99543 23.7873Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66145 23.526C8.82317 23.3696 8.1088 22.6375 7.95059 22.7921C7.79239 22.9468 8.50149 23.6825 8.66145 23.526Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1455 21.2977C7.61484 21.1535 7.06921 19.3641 6.60023 19.5078C6.13089 19.652 6.68548 21.4432 7.14568 21.2975",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96269 20.9101C7.17767 20.8443 6.87744 19.867 6.66597 19.931C6.45451 19.995 6.75123 20.9758 6.96269 20.9101Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.947 25.4401C12.153 24.9957 10.2677 24.1144 10.0615 24.5603C9.85552 25.0064 11.739 25.8843 11.947 25.4401Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4921 25.2979C11.5863 25.0935 10.5574 24.612 10.4615 24.8145C10.3655 25.0172 11.3996 25.5006 11.4921 25.2979Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21846 22.9059C7.62891 22.641 6.61254 21.0683 6.20385 21.3367C5.79516 21.6049 6.80449 23.1724 7.21846 22.9059Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93246 22.5842C7.12072 22.4615 6.56455 21.6033 6.37804 21.7241C6.19154 21.8448 6.74578 22.7049 6.93246 22.5842Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8876 27.9158C14.6781 27.3825 12.6789 28.1646 12.8886 28.703C13.0983 29.2414 15.0991 28.4525 14.8876 27.9158Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4629 28.1626C14.3652 27.9157 13.2725 28.3404 13.3666 28.591C13.4608 28.8417 14.5589 28.4063 14.4629 28.1626Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3182 28.5395C12.185 27.9334 10.3635 28.3368 10.4952 28.9429C10.6267 29.5488 12.4534 29.1454 12.3182 28.5395Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.922 28.7172C11.8598 28.4383 10.8559 28.6603 10.9234 28.9357C10.9909 29.2112 11.9842 28.9837 11.922 28.7172Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3466 25.8577C15.8987 25.3638 14.3599 26.7658 14.8059 27.2563C15.252 27.7467 16.7943 26.3499 16.3466 25.8577Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0552 26.2292C15.849 26.0035 15.0086 26.7711 15.2128 26.9951C15.4173 27.219 16.2594 26.4619 16.0552 26.2292Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1273 29.1721C10.115 28.7172 8.50325 28.7402 8.51749 29.1971C8.53155 29.6538 10.1398 29.6306 10.1273 29.1721Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76482 29.2361C9.76482 29.0264 8.87642 29.0424 8.87642 29.2484C8.87642 29.4548 9.77009 29.4458 9.76482 29.2361Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6927 30.8853C15.5595 30.2793 13.738 30.6828 13.8677 31.2887C13.9975 31.8948 15.8259 31.4914 15.6927 30.8853Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2965 31.0542C15.2343 30.7751 14.2302 30.9955 14.2977 31.2727C14.3652 31.5499 15.3587 31.3279 15.2965 31.0542Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8457 29.7657C20.4903 29.2574 18.9585 30.3291 19.314 30.832C19.6694 31.3349 21.2011 30.2757 20.8457 29.7657Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5453 30.0732C20.3801 29.8402 19.5451 30.4286 19.7051 30.6578C19.8649 30.887 20.7053 30.3041 20.5453 30.0732Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6121 31.4149C17.9937 31.4486 18.0969 33.3165 18.717 33.2827C19.3372 33.249 19.2322 31.3829 18.6121 31.4149Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7153 31.8326C18.4308 31.8484 18.4878 32.8704 18.7685 32.8544C19.0492 32.8386 18.9977 31.8166 18.7153 31.8326Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6764 33.3005C19.0688 33.4248 19.4419 35.2552 20.0496 35.1362C20.6573 35.0172 20.2841 33.178 19.6764 33.3005Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8346 33.6932C19.5557 33.7519 19.7599 34.7595 20.0371 34.699C20.3143 34.6387 20.1136 33.6435 19.8346 33.6932Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0758 35.2499C18.4681 35.3744 18.8413 37.205 19.449 37.084C20.0568 36.9633 19.6836 35.1274 19.076 35.2499",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2375 35.6481C18.9585 35.705 19.1612 36.7144 19.4402 36.6521C19.7191 36.5899 19.5129 35.5913 19.2375 35.6481Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4673 37.2832C19.8613 37.4057 20.2326 39.2379 20.8403 39.1154C21.4481 38.9927 21.0785 37.1587 20.4673 37.283",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6307 37.6812C20.35 37.7399 20.5543 38.7475 20.8315 38.6852C21.1087 38.623 20.9007 37.6244 20.6307 37.6812Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1226 39.4264C19.5059 39.4496 19.5734 41.319 20.1936 41.296C20.8137 41.2729 20.7445 39.4033 20.1226 39.4264Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2184 39.8475C19.9324 39.86 19.9714 40.8818 20.254 40.8712C20.5365 40.8605 20.4993 39.8369 20.2184 39.8475Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4318 42.0743C19.9501 41.6833 18.964 42.8989 19.4474 43.29C19.9306 43.6809 20.9132 42.4635 20.4318 42.0743Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.27 42.4013C20.0479 42.2237 19.5094 42.8882 19.7369 43.0661C19.9644 43.2436 20.4885 42.5792 20.27 42.4013Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8075 43.226C18.5588 42.7746 17.4215 43.4035 17.6702 43.8514C17.9191 44.2993 19.0563 43.6774 18.8075 43.226Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5906 43.425C18.4771 43.2171 17.8552 43.56 17.9671 43.7643C18.0791 43.9689 18.6954 43.6312 18.5906 43.425Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3718 44.6015C17.3345 44.1339 16.2186 44.2246 16.2577 44.692C16.2969 45.1596 17.4108 45.0671 17.3718 44.6015Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1248 44.6798C17.1072 44.4664 16.4976 44.5145 16.5136 44.7277C16.5294 44.941 17.1425 44.8895 17.1248 44.6798Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8115 44.3224C15.9112 43.9066 14.9233 43.6667 14.8201 44.0826C14.7171 44.4983 15.7104 44.7383 15.8115 44.3224Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.57 44.3189C15.6145 44.1306 15.0725 43.999 15.0263 44.1856C14.9801 44.3723 15.529 44.5091 15.57 44.3189Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3156 44.3563C14.4791 43.9599 13.5355 43.5688 13.3738 43.9652C13.2121 44.3615 14.1486 44.7437 14.3156 44.3563Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0827 44.3083C14.1557 44.1306 13.6403 43.9154 13.5657 44.0931C13.491 44.2708 14.0082 44.4895 14.0827 44.3083Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4733 43.3005C13.7862 43.0091 13.0894 42.261 12.7784 42.5524C12.4675 42.8438 13.1606 43.592 13.4733 43.3005Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2761 43.1673C13.4183 43.0323 13.0396 42.6234 12.8976 42.7567C12.7554 42.8901 13.1339 43.3005 13.2761 43.1673Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3237 41.9642C12.7341 41.8468 12.4497 40.864 12.0393 40.985C11.6288 41.1057 11.915 42.0852 12.3237 41.9642Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.208 41.7581C12.3857 41.7029 12.2402 41.1662 12.0535 41.2249C11.867 41.2835 12.0161 41.8149 12.208 41.7581Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4235 32.3728C13.3703 31.7561 11.5081 31.9161 11.5631 32.5362C11.6181 33.1566 13.4786 32.9931 13.4235 32.3728Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0096 32.4882C12.9829 32.204 11.9665 32.2945 11.9913 32.5754C12.0162 32.8562 13.0344 32.7691 13.0096 32.4882Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1881 31.7224C11.1758 31.1128 9.30814 31.1502 9.32238 31.7614C9.33644 32.3728 11.2024 32.3337 11.1881 31.7224Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7724 31.8094C10.7724 31.5286 9.74531 31.5517 9.75058 31.8291C9.75586 32.1063 10.7724 32.0938 10.7724 31.8094Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07189 32.4954C8.93865 31.909 7.31267 32.2804 7.44943 32.8704C7.58636 33.4605 9.20865 33.0853 9.07189 32.4954Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72173 32.6554C8.65968 32.387 7.77111 32.5915 7.83334 32.8579C7.89556 33.1246 8.78396 32.9254 8.72173 32.6554Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81153 32.5399C6.53626 32.0068 5.17676 32.7034 5.45591 33.2508C5.73487 33.7981 7.08716 33.0783 6.81153 32.5399Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53977 32.7674C6.4118 32.5202 5.67264 32.9059 5.79516 33.1476C5.91785 33.3893 6.66598 33.0126 6.53977 32.7674Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37943 34.0787C4.92979 33.8762 4.41439 35.0174 4.8658 35.2199C5.31721 35.4224 5.83084 34.2833 5.37943 34.0789",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3209 34.3651C5.11471 34.2709 4.83399 34.8982 5.03649 34.987C5.23899 35.0759 5.52692 34.4556 5.32072 34.3651",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11961 35.4561C3.62742 35.4561 3.63094 36.7091 4.11961 36.7001C4.60828 36.6913 4.61355 35.4544 4.11961 35.4561Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18535 35.7405C3.95613 35.7405 3.95965 36.4247 4.18535 36.4247C4.41106 36.4247 4.41106 35.7388 4.18535 35.7405Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60107 37.0698C4.16214 37.1498 4.36833 38.2713 4.80902 38.1878C5.2497 38.1041 5.04351 36.9933 4.60107 37.0698Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70601 37.3187C4.50158 37.3577 4.61531 37.9691 4.81605 37.9318C5.01697 37.8944 4.90851 37.2814 4.70601 37.3187Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55309 38.6925C4.19783 38.8897 4.7025 39.789 5.05776 39.581C5.41319 39.3731 4.90834 38.4915 4.55309 38.6925Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70602 38.8684C4.5443 38.9607 4.81975 39.4513 4.98147 39.3588C5.14319 39.2664 4.8695 38.7777 4.70602 38.8684Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60865 39.8865C5.36168 40.1267 5.96408 40.7558 6.21984 40.5123C6.47578 40.2687 5.85562 39.6433 5.60865 39.8865Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77741 39.9969C5.66367 40.1087 5.99959 40.4501 6.11139 40.3397C6.22354 40.2296 5.89114 39.8867 5.77741 39.9969Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98082 28.9642C8.12127 28.3723 6.30334 27.9406 6.16131 28.536C6.0191 29.1312 7.83862 29.5613 7.98082 28.9642Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5491 28.9447C7.61308 28.671 6.6215 28.4363 6.55576 28.7065C6.49001 28.9767 7.48704 29.2149 7.5491 28.9447Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65136 29.1241C5.8289 28.6177 4.06634 27.9991 3.88863 28.5075C3.71091 29.0157 5.4754 29.6342 5.65136 29.1241Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23019 29.0496C5.31193 28.8149 4.34161 28.479 4.26515 28.71C4.18886 28.9411 5.14845 29.2825 5.23019 29.0496Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06089 27.7949C4.41632 27.395 3.0375 26.1385 2.67486 26.5366C2.3124 26.9346 3.70019 28.1928 4.06089 27.7949Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70196 27.5602C3.86719 27.3827 3.10852 26.6911 2.94505 26.8706C2.78157 27.0502 3.53673 27.7414 3.70196 27.5602Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79894 26.5064C2.24841 26.2078 1.20902 24.651 0.761128 24.9495C0.313413 25.2482 1.35474 26.8049 1.79894 26.5064Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50925 26.1918C1.71368 26.0532 1.15382 25.2056 0.942532 25.3389C0.731067 25.4721 1.30499 26.3268 1.50925 26.1918Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16103 24.2866C1.66553 24.0966 1.00107 22.3478 0.500096 22.5362C-0.00105649 22.7246 0.660057 24.4786 1.16103 24.2866Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.947805 23.9189C1.17878 23.83 0.814563 22.8739 0.592375 22.9609C0.370364 23.0481 0.718586 24.0024 0.947805 23.9189Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.231686 21.8716C0.626139 21.9161 0.777135 20.5404 0.382858 20.4961C-0.0117708 20.4516 -0.164525 21.8271 0.231686 21.8716Z",
    fill: "#FACFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.215682 21.5552C0.393397 21.5729 0.476893 20.8213 0.299178 20.8035C0.121639 20.7858 0.0344518 21.5339 0.215682 21.5552Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92665 19.8703C6.4118 19.8118 6.18434 17.9529 5.69918 18.0151C5.21403 18.0774 5.44166 19.9308 5.92665 19.8703Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81309 19.4581C6.03686 19.4316 5.91065 18.415 5.6904 18.4416C5.46997 18.4683 5.59108 19.4848 5.81309 19.4581Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65331 18.383C7.14023 18.4238 7.2914 16.5579 6.80097 16.5187C6.31054 16.4796 6.16288 18.3438 6.65331 18.383Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62519 17.9547C6.84896 17.9724 6.92894 16.9541 6.70675 16.9346C6.48474 16.9151 6.40125 17.9387 6.62519 17.9547Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12931 16.062C6.57351 16.2664 7.34994 14.5656 6.90398 14.3613C6.45802 14.1569 5.68142 15.8593 6.12931 16.062Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24832 15.6516C6.45082 15.7438 6.87551 14.8163 6.67477 14.722C6.47403 14.6278 6.04407 15.5663 6.24832 15.6516Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60781 14.6936C8.00753 14.9175 8.85146 13.3963 8.4498 13.1741C8.04831 12.9519 7.20439 14.4696 7.60781 14.6936Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7516 14.3221C7.92914 14.4253 8.39496 13.5953 8.2118 13.4923C8.02881 13.3891 7.56317 14.2191 7.7516 14.3221Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88133 12.8187C8.22234 13.0853 9.2032 11.8271 8.85867 11.5586C8.51396 11.2902 7.53486 12.545 7.88133 12.8187Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05904 12.4988C8.21549 12.6215 8.75197 11.9336 8.59201 11.8111C8.43205 11.6884 7.90084 12.3762 8.05904 12.4988Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52858 12.0528C9.85729 12.3388 10.8984 11.1303 10.568 10.846C10.2375 10.5616 9.20339 11.7684 9.52858 12.0528Z",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72931 11.7434C9.87872 11.8751 10.44 11.2103 10.298 11.0842C10.1558 10.958 9.57656 11.6137 9.72931 11.7434Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2765 10.4426C10.5734 10.6986 11.4244 9.71032 11.1259 9.45456C10.8274 9.19862 9.97805 10.1849 10.2765 10.4424",
    fill: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4312 10.1848C10.568 10.3022 11.0336 9.76203 10.8967 9.65182C10.7599 9.5416 10.2962 10.0695 10.4312 10.185",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7035 10.1245C12.0375 10.3272 12.7146 9.21288 12.3768 9.00844C12.0393 8.80401 11.3641 9.91811 11.7035 10.1245Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8136 9.84552C11.9647 9.93798 12.336 9.33013 12.1832 9.23591C12.0303 9.14169 11.6608 9.75306 11.8136 9.84552Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8385 8.78628C12.2135 8.89649 12.503 7.9297 12.1245 7.81772C11.7461 7.70575 11.4653 8.67255 11.8385 8.78628Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8635 8.55177C12.041 8.60327 12.1922 8.07364 12.0197 8.01862C11.8475 7.96343 11.6912 8.50027 11.8635 8.55177Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8781 7.70943C13.2476 7.5797 12.9154 6.62697 12.5422 6.75846C12.169 6.89012 12.5068 7.84267 12.8781 7.70943Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7554 7.51028C12.9329 7.4535 12.7413 6.9309 12.5779 6.99137C12.4144 7.05184 12.5866 7.56899 12.7554 7.51028Z",
    fill: "#E34E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.938 6.60761C12.0002 6.22001 11.0051 6.06374 10.9431 6.45292C10.8807 6.8421 11.8775 7.0003 11.938 6.60761Z",
    fill: "#F389A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7053 6.6217C11.7338 6.44416 11.1881 6.36049 11.1616 6.53645C11.1349 6.71223 11.6768 6.79942 11.7053 6.6217Z",
    fill: "#E34E70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_316_301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2231.47 2211.99) scale(2233.6 2233.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E03330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D52E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C32827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#A91F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#89181A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#640E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_301",
    x1: 3.71592,
    y1: 607.38,
    x2: 1247.38,
    y2: 607.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F7B0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6A4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F390A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E7728B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DC4D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA4B6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_316_301",
    x1: 0.505935,
    y1: 324.459,
    x2: 1697.11,
    y2: 324.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F7B0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6A4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F390A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E7728B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DC4D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA4B6A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_316_301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(439.476 425.279) scale(781.312 781.314)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F7B0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6A4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F390A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E7728B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DC4D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA4B6A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_316_301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(880.144 884.272) scale(966.463 966.464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F7B0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6A4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F390A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E7728B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DC4D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA4B6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_316_301",
    x1: 28.8844,
    y1: 607.388,
    x2: 1272.37,
    y2: 607.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA4B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DC4D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E7728B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F390A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6A4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F7B0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B3C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_316_301",
    x1: 27.879,
    y1: 324.631,
    x2: 1724.66,
    y2: 324.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA4B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DC4D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E7728B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F390A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6A4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F7B0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B3C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_316_301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(473.968 425.121) scale(781.314 781.309)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B3C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F7B0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6A4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F390A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E7728B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DC4D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA4B6A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactTestingLibrary);
export default __webpack_public_path__ + "static/media/ReactTestingLibrary.00d10ffb7de7c81d2802147d614689e6.svg";
export { ForwardRef as ReactComponent };